import EventsComponent from "@/components/Events/EventsComponent";

const Events = () => {
  return <EventsComponent />;
};

export default Events;
